import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Fun from 'gw-portals-util-js/FunUtil';

var fn = function fn($scope, AccountBillingDetailsService, $q, $state, $stateParams, PolicyService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        var state = void 0;

        // Gateway portal
        if ($stateParams.accountNumber) {
            state = AccountBillingDetailsService.getAccountBillingDetails($stateParams.accountNumber);
        } else {
            state = AccountBillingDetailsService.getAccountBillingDetails();
        }

        $scope.agentBillingDetailsPromise = state;
        $q.when(state, Fun.setter($scope, 'billingInfo')).then(getPolicySummariesFromBillingInfoAndAddToPaymentGroup);
    };

    function getPolicySummariesFromBillingInfoAndAddToPaymentGroup() {
        if (angular.isDefined($scope.billingInfo.paymentGroups)) {
            if ($scope.billingInfo.paymentGroups.length > 0) {
                $scope.billingInfo.paymentGroups.forEach(function (group) {
                    PolicyService.getPolicySummariesFromPolicyNumbers(group.relatedPolicies).then(function (policySummaries) {
                        group.relatedPolicies = policySummaries;
                    });
                });
            }
        }
    }

    return ctrl.create($scope);
};

fn.$inject = ['$scope', 'billing.AccountBillingDetailsService', '$q', '$state', '$stateParams', 'PolicyService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/GatewayBillingDetailsCtrl.js
// module id = 1672
// module chunks = 0